import { ALPHA__Drawer as Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/ALPHA/Drawer";
import styles from "./PartnershipCardPointsSideDrawer.module.scss";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";

import OpenInNew24PxOutlinedIcon from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/OpenInNew24PxOutlined";

type PartnershipCardPointsSideDrawerProps = {
  handleClose: () => void;
  drawerIsOpen: boolean;
  points: number;
};

export const PartnershipCardPointsSideDrawer = ({
  handleClose,
  drawerIsOpen,
  points,
}: PartnershipCardPointsSideDrawerProps) => {
  return (
    <Drawer
      isOpen={drawerIsOpen}
      onClose={handleClose}
      header="Partnership Credit Card"
      footerClassName={styles.footerLayout}
      footerChildren={
        <>
          <UnderlinedButton
            className={styles.findOutMore}
            tag="a"
            target="_blank"
            data-testid="cardpoints:link:findoutmore"
            href="https://www.johnlewisfinance.com/credit-cards/partnership-card.html?sourcecode=3521501AAJLPDOM16500&utm_source=www.johnlewis.com&utm_medium=Banner&utm_campaign=PC0243&track=jli:acquisition%7CPC0243"
          >
            Find out more
          </UnderlinedButton>
          <OpenInNew24PxOutlinedIcon />
        </>
      }
      fullPage={true}
      className={styles.sideDrawer}
      isDrawerLeft={false}
      isHeaderFixed={true}
      isFooterFixed={true}
      isNarrow={false}
      rootId="page-root"
      contentClassName={styles.drawerContent}
      isLegacySPDPDrawer={true}
    >
      <div className={styles.drawerContent__highlightWrapper}>
        <h3>
          Earn <strong>{points} points</strong> when you pay for this product
          with your <strong>Partnership Credit Card.</strong>
        </h3>
        <h3>
          <strong>{`28.9% APR Representative`}</strong> (variable).
        </h3>
        <div
          className={
            styles.drawerContent__highlightWrapper__findOutMoreContainer
          }
        >
          <UnderlinedButton
            className={styles.drawerContent__highlightWrapper__findOutMore}
            tag="a"
            target="_blank"
            data-testid="cardpoints:link:findoutmore"
            size="large"
            href="https://www.johnlewisfinance.com/credit-cards/partnership-card.html?sourcecode=3521501AAJLPDOM16500&utm_source=www.johnlewis.com&utm_medium=Banner&utm_campaign=PC0243&track=jli:acquisition%7CPC0243"
          >
            Find out more
          </UnderlinedButton>
          <OpenInNew24PxOutlinedIcon />
        </div>
      </div>
      <div className={styles.drawerContent__infoWrapper}>
        <h3>
          <strong>{`Your Partnership Credit Card Benefits`}</strong>
        </h3>
        <h4>{`Earn points`}</h4>
        <p>
          {`For every 500 points, we'll send you a £5 voucher to treat yourself at John Lewis or Waitrose.*`}
        </p>
        <h4>{`Instant spend`}</h4>
        <p>
          {`Apply now and, if accepted, download the John Lewis Credit Card app, follow the prompts and start using your Partnership Credit Card to pay online or with your phone, wherever Apple Pay and Google Pay™️ are accepted.†`}
        </p>
        <h4>{`No annual fee and widely accepted`}</h4>
        <div className={styles.drawerContent__infoWrapper__borderWrapper}>
          <p>{`Check your eligibility without impacting your credit score.`}</p>
        </div>{" "}
        <h3>
          <strong>{`John Lewis plc is a credit broker and not a lender, introducing the Partnership Credit Card under exclusive arrangements with the lender NewDay Ltd.`}</strong>
        </h3>
        <div className={styles.drawerContent__infoWrapper__smallPrintWrapper}>
          <p>
            {`John Lewis Finance is a trading name of John Lewis plc, registered in England with company number 233462, registered office: 171 Victoria Street, London SW1E 5NN. Authorised and regulated by the Financial Conduct Authority (FRN 724309).`}
          </p>
          <p>{`Credit subject to status. 18 years +. UK residents. T&Cs apply.`}</p>
          <p>
            {`* Rewards subject to terms and conditions - see `}{" "}
            <a
              href="http://www.johnlewiscreditcard.com/terms"
              target="_blank"
              rel="noreferrer"
            >{`johnlewiscreditcard.com/terms`}</a>
          </p>
          <p>{`† Google Pay is a trademark of Google LLC. `}</p>
        </div>
      </div>
    </Drawer>
  );
};
